import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import Button from '../../Button/Button';
import { Routes as RoutesEnum, Routes } from '../../../constants/routes';
import { recoveryConfirm } from '../../../store/reducers/PasswordRecovery/passwordRecoverySlice';
import Heading from '../../Typography/Heading/Heading';
import styles from '../LoginModal/LoginModal.module.scss';
import cn from 'classnames';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import { Field, Form, Formik } from 'formik';
import PasswordInput from '../../Form/PasswordInput/PasswordInput';
import TextError from '../../TextError/TextError';
import { firstLetterUpperCase } from '../../../helpers';
import Modal from '../../Modal/Modal';
import { useTranslation } from 'react-i18next';
import { usePasswordRecoveryValidationSchema } from '../../../validations/PasswordRecovery';
import Loader from '../../Loader/Loader';
import { setConfirmPasswordModal } from '../../../store/reducers/ModalsState/slice';
const RecoveryPasswordConfirm = () => {
    const dispatch = useAppDispatch();
    const { search } = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const { t } = useTranslation();
    const { error, readyToLogin, pending } = useAppSelector((state) => state.passwordRecovery);
    const usePasswordRecovery = usePasswordRecoveryValidationSchema();
    useEffect(() => {
        if (readyToLogin) {
            navigate(RoutesEnum.MY_ACCOUNT);
            dispatch(setConfirmPasswordModal(true));
        }
    }, [dispatch, navigate, readyToLogin]);
    return (_jsxs(Modal, Object.assign({ background: true, closeModal: () => navigate(Routes.HOME) }, { children: [_jsx(Heading, { className: styles.heading, title: t('create_new_password') }), _jsx("div", Object.assign({ className: cn('d-flex align-items-center', styles.descBox) }, { children: _jsx(Paragraph, { size: 2, className: styles.desc, title: t('please_enter_the_password') }) })), _jsx(Formik, Object.assign({ initialValues: {
                    password: '',
                    newPassword: ''
                }, onSubmit: (values) => {
                    if (!token)
                        return;
                    dispatch(recoveryConfirm({ token, password: values.password }));
                }, validationSchema: usePasswordRecovery }, { children: ({ handleChange, handleBlur, values, handleSubmit }) => (_jsxs(Form, Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(Field, { label: t('enter_new_password'), className: "w-100", type: "password", name: "password", id: "password", onChange: handleChange, onBlur: handleBlur, hideIcon: true, value: values.newPassword, component: PasswordInput }), _jsx(Field, { label: t('repeat_new_password'), className: "w-100", type: "password", name: "newPassword", id: "newPassword", onChange: handleChange, onBlur: handleBlur, hideIcon: true, value: values.newPassword, component: PasswordInput }), pending ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { height: 'sm', size: '100', type: 'submit', text: t('create_a_password') }))] }))) })), error && _jsx(TextError, { text: firstLetterUpperCase(error) })] })));
};
export default RecoveryPasswordConfirm;
